/* Helper Functions */
export const createImageFromSrc = (src: string) => {
  // src can be a base64 string or a url
  if (!src) return null;
  const img = new Image();
  img.src = src;

  return img;
};

export const measureTextSize = (text: string, fontSize = 18, fontFamily = 'Manrope') => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) return { width: 100, height: 30 };

  ctx.font = `${fontSize}px ${fontFamily}`;
  const lines = text.split('\n');
  const maxWidth = Math.max(...lines.map((line) => ctx.measureText(line).width));

  const lineHeight = fontSize * 1.2; // spacing between lines
  const height = lines.length * lineHeight;

  return { width: maxWidth + 10, height };
};

export const tooltipStyle = {
  '& .MuiTooltip-tooltip': {
    borderRadius: '0.5rem',
    bgcolor: '#F0F0F1',
    boxShadow: 2,
    padding: '.5rem',
    position: 'relative',
    color: '#6C6C6C',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1rem',
  },
};
